import { Component, OnInit } from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';

@Component({
  selector: 'app-public-patient-portal',
  templateUrl: './public-patient-portal.component.html',
  styleUrls: ['./public-patient-portal.component.scss']
})
export class PublicPatientPortalComponent implements OnInit {

  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0)
      }
    });
  }

  ngOnInit(): void {
  }

}
